import { Pressable } from 'react-native';
import styled from 'styled-components/native';
import { BoxProps } from '@/components/base/box';
import { AppCardView } from '@/components/base/app.card.view';
import { hpVal } from '../../../utils';

const DEFAULT_PALETTE = { sentBg: '#FFFAE0', sentBorder: '#FFE59C' };

export function ChatContainer({
  children,
  isSentByUser,
  style,
  onLongPress,
}: {
  children: any;
  isSentByUser: boolean;
  style?: BoxProps['style'];
  onLongPress?: (e: any) => void;
}) {
  return (
    <Pressable onLongPress={onLongPress}>
      <Component $isSentByUser={isSentByUser} style={style} shadowColor={'#000'} shadowOpacity={0.06} blurRadius={8} shadowOffsetX={0} shadowOffsetY={3}>
        {children}
      </Component>
    </Pressable>
  );
}

const Component = styled(AppCardView)<{ $isSentByUser: boolean }>`
  margin-top: ${hpVal(0.8)};
  margin-bottom: 10px;
  padding-top: 12px;
  padding-right: 12px;
  padding-left: 12px;
  padding-bottom: 0;
  border-radius: ${hpVal(1.6)};
  border-bottom-left-radius: ${({ $isSentByUser, theme }) => ($isSentByUser ? theme.hp(1.6) : theme.hp(0.8))}px;
  border-bottom-right-radius: ${({ $isSentByUser, theme }) => ($isSentByUser ? theme.hp(0.8) : theme.hp(1.6))}px;
  background-color: ${({ theme, $isSentByUser }) => ($isSentByUser ? DEFAULT_PALETTE.sentBg : theme.colors.white)};
  border-color: ${({ $isSentByUser }) => ($isSentByUser ? DEFAULT_PALETTE.sentBorder : '#edeeea')};
`;
